<template>
	<div id="story_content">
		<div class="background-interactive">
			<div class="item-background-bg" ref="image_hojas">
				<img :src="load_images('bg_visiones.jpg')" />	
			</div>
		</div>
		<div class="cover-story-wrapper" ref="container_cover_story">
			<div class="images-cover-story" ref="image_story_cover">
				<img :src="load_images(`${content.foto_portada}`)" :style="`${content.foto_portada_movil}`" />
			</div>
		</div>

		<div class="intro-story-wrapper">
			<div class="cover-content text-center margin-cover">
				<div class="container-content">
					<h2 class="text-center">{{ content.title }}</h2>
					<div class="story_by">Por: {{ content.autor }}</div>
					<div class="story_by" v-if="content.fotos">Fotos: {{ content.fotos }}</div>
					<div class="story_by">Agosto 2021</div>
					<div class="text-center mt-5">
						<ShareNetwork
							network="facebook"
							:title="`${content.title} via @ojo_publico`"
							:description="content.bajada"
							:quote="content.bajada"
							:url="`/#/${$i18n.locale}/${content.url}`"
						>
							<font-awesome-icon :icon="['fab', 'facebook']" class="iconos-redes" />
						</ShareNetwork>
						
						<ShareNetwork
							network="twitter"
							:url="`https://ojo-publico.com/especiales/visiones-del-coronavirus/#/${$i18n.locale}/${content.url}`"
							:title="`${content.title} vía @ojo_publico`"
							:description="content.bajada"
							:quote="content.bajada"
						>
							<font-awesome-icon :icon="['fab', 'twitter']" class="iconos-redes" />
						</ShareNetwork>
					</div>
				</div>
			</div>
		</div>

		<div class="intro-story-wrapper">
			<div class="cover-content text-center content-bajada">
				<div class="container-content">
					<p><span v-html="content.bajada"></span></p>
				</div>
			</div>
		</div>
		
		<div class="container-story mt-5 mb-5">			
			<div class="row justify-content-center pb-5">
				<div class="col-12 col-md-9 pt-5">										
					<div v-if="!content.title ">
						Loading
					</div>					
					<div v-if="content.title">

						<p>{{ content.imagen }}</p>
						<div class="content" v-html="content.body_1"></div>						
					</div>
				</div>
						
			</div>			
		</div>

		<b-modal size="xl" centered hide-footer hide-header @hidden="closePicture" :visible="picture_xl!=``" id="picture-open-xl">
			<div class="row">
				<div class="col-12 col-md-9">
					<img class="picture-open-full" :src="picture_xl" />
				</div>
				<div class="col-12 col-md-3">
					<div class="description"><span v-html="picture_full_description"></span></div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<style lang="scss">

	.picture-open-full {
		width: 100%;
	}

	.modal-dialog-centered {
		max-width: 90%;

		@media (max-width: 575.98px) {
			max-width: 100%;
		}

		div.description {
			padding: 15px;
			font-size: 14px;
			font-size: 'asap';
		}
	}

</style>

<script>

import utils from '@/mixins/utils'

export default {
	name: 'Story',
	mixins: [utils],
	props: {
		content: Object
	},
	data()  {
		return {
			picture_xl: ``,
			picture_full_description: ``
		}
	},
	watch: {
		content(values) {
			this.picture_xl = ``
			document.title = `${values.title} | Ojo Público`
			setTimeout(() => {
				this.load_big_frame()
			}, 1500)
		}
	},
	mounted() {

		document.querySelector('.topbar-especial').style.background = `transparent`

		document.querySelector(`.navigation_stories`).classList.remove('active_nav')

		document.querySelector(`.topbar-especial`).classList.remove('active_nav')

		this.load_big_frame()

		document.title = `${this.content.title} | Ojo Público`

		window.addEventListener('scroll', () => {
			this.scrollTransition()
		})
	},
	methods: {
		load_big_frame() {
			
			let elements = document.querySelectorAll(`.contenido-imagen`)

			Array.from(elements).map(item => {
				item.querySelector('img').onclick = () => {
					this.picture_xl = item.querySelector('img').src
					this.picture_full_description = item.querySelector('span').innerHTML
				}
			})
		},
		closePicture() {
			this.picture_xl = ``
		},
		scrollTransition() {

			if(!document.querySelector('.item-background-bg') || !this.$refs['container_cover_story'])
				return false

			if(window.scrollY > (window.innerHeight*.8)) {
				this.$refs['container_cover_story'].style.opacity = 0
				document.querySelector('.item-background-bg').style.opacity = 1
				document.querySelector('.topbar-especial').style.background = `linear-gradient(0deg, rgba(202, 1, 1, 0) 0%, rgb(18 43 66) 117%)`
			} else {
				this.$refs['image_story_cover'].style.opacity = 1
				this.$refs['container_cover_story'].style.opacity = 1
				document.querySelector('.topbar-especial').style.background = `transparent`
			}
		}	
	}
}
</script>
